import React, { useContext, useMemo } from "react"
import MenuIcon from "@mui/icons-material/Menu"
import { AppBar, IconButton, Toolbar, Typography } from "@mui/material"
import { Tag } from "antd"
import packageJson from "../../../../package.json"
import { useIsMobile } from "../../../hooks/useIsMobile.js"
import { useNavigation } from "../../hooks/use-navigation.js"
import { NewLayoutToggle } from "./new-layout-toggle"
import { SidebarContext } from "./sidebar/contexts/sidebar-context.js"

/**
 * Barra superior usada nos layouts novos, exibindo usuário e ambiente
 * @returns {React.ReactElement}
 */
export function NewLayoutTopBar() {
  const isMobile = useIsMobile()
  const sidebarContext = useContext(SidebarContext)
  const { navigateWithLoading } = useNavigation()
  const [useNewLayout, setUseNewLayout] = React.useState(() => {
    if (typeof window === "undefined") {
      return true
    }
    return localStorage.getItem("use_new_layout") === "true"
  })

  const usuario = useMemo(() => {
    try {
      const stored = localStorage.getItem("user_token")
      return stored ? JSON.parse(stored) : {}
    } catch (error) {
      console.error("Erro ao ler user_token:", error)
      return {}
    }
  }, [])

  const envColor = packageJson?.ambiente === "Homologação" ? "orange" : "#000"
  const envLabel = `${packageJson?.ambiente || "Ambiente"}: ${packageJson?.version || "0.0.0"}`

  const handleDrawerOpen = () => {
    if (sidebarContext?.setSidebarOpen) {
      sidebarContext.setSidebarOpen(true)
    }
  }

  const handleLayoutToggle = (event) => {
    const newValue = event.target.checked
    setUseNewLayout(newValue)
    localStorage.setItem("use_new_layout", newValue.toString())

    window.dispatchEvent(new Event("newLayoutPreferenceChanged"))

    if (!newValue) {
      navigateWithLoading("/listSale")
    }
  }

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: "#000000",
        color: "#fff",
        paddingRight: 2,
        zIndex: 10,
      }}
    >
      <Toolbar sx={{ minHeight: 64, gap: 1 }}>
        {isMobile && sidebarContext && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              mr: 1,
              ...(sidebarContext?.sidebarOpen && { visibility: "hidden" }),
            }}
          >
            <MenuIcon />
          </IconButton>
        )}
        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
          {usuario?.name || "Usuário"}
        </Typography>

        <NewLayoutToggle isMobile={isMobile} />

        <Tag color={envColor} style={{ marginLeft: "auto" }}>
          {envLabel}
        </Tag>
      </Toolbar>
    </AppBar>
  )
}
